export type ImportedMessages = Record<string, string | null>;
export type DisplayMessages = Record<string, string>;

const allowedNullTranslationSuffixes = ['.other', '.zero', '.few', '.many', '.two'];

export const isAllowedNullTranslationKey = (key: string) =>
    allowedNullTranslationSuffixes.some(suffix => key.endsWith(suffix));

export const normalizeDisplayMessages = (messages: ImportedMessages): DisplayMessages =>
    Object.entries(messages).reduce<DisplayMessages>((displayMessages, [key, value]) => {
        if (value !== null) {
            displayMessages[key] = value;
        }

        return displayMessages;
    }, {});
